import { createContainer } from 'unstated-next';
import { usePaymentMethod } from '../hooks/usePaymentMethod';

export const PaymentMethodStore = createContainer(usePaymentMethod);
export const usePaymentMethodStore = () => {
  return PaymentMethodStore.useContainer();
};
